import { render } from "./Flexmonster.vue?vue&type=template&id=837dbd54&scoped=true"
import script from "./Flexmonster.vue?vue&type=script&lang=js"
export * from "./Flexmonster.vue?vue&type=script&lang=js"

import "./Flexmonster.vue?vue&type=style&index=0&id=837dbd54&scoped=true&lang=css"
import "./Flexmonster.vue?vue&type=style&index=1&id=837dbd54&lang=css"

import exportComponent from "/woodpecker/src/github.com/Multpex/multpex.front.gestao/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-837dbd54"]])

export default __exports__
import QSpinnerGears from 'quasar/src/components/spinner/QSpinnerGears.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QSpinnerGears});
